import './styles/style.scss';
import Filterizr from 'filterizr';

(function () {
	'use strict';

	function qs(sel, root) { return (root || document).querySelector(sel); }
	function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
	function parseJSONAttr(el, name, fallback) {
		try { return JSON.parse(el.getAttribute(name) || '') || fallback; } catch (e) { return fallback; }
	}

	function renderPagination(block, attrs, currentPage, totalPages) {
		var nav = qs('[data-locations-pagination]', block);
		if (!nav) return;

		var mode = nav.getAttribute('data-mode') || 'numbers';
		if (mode === 'none' || totalPages <= 1) { nav.style.display = 'none'; return; }
		nav.style.display = '';

		var prevBtn = qs('[data-page-prev]', nav);
		var nextBtn = qs('[data-page-next]', nav);
		if (prevBtn) prevBtn.disabled = currentPage <= 1;
		if (nextBtn) nextBtn.disabled = currentPage >= totalPages;

		var numbersWrap = qs('[data-page-numbers]', nav);
		if (!numbersWrap) return;

		numbersWrap.innerHTML = '';
		if (mode !== 'numbers') return;

		var start = Math.max(1, currentPage - 4);
		var end = Math.min(totalPages, start + 9);
		start = Math.max(1, end - 9);

		for (var i = start; i <= end; i++) {
			var btn = document.createElement('button');
			btn.type = 'button';
			btn.className = 'locations-page-number' + (i === currentPage ? ' is-active' : '');
			btn.setAttribute('data-page', String(i));
			btn.textContent = String(i);
			numbersWrap.appendChild(btn);
		}
	}

	function updateUrl(attrs, regionSlug, page, sort, dir) {
		if (!attrs.paginationUpdateUrl) return;
		var url = new URL(window.location.href);
		if (regionSlug) url.searchParams.set('region', regionSlug); else url.searchParams.delete('region');
		if (page && page > 1) url.searchParams.set('paged', String(page)); else url.searchParams.delete('paged');
		if (sort) url.searchParams.set('sort', sort); else url.searchParams.delete('sort');
		if (dir) url.searchParams.set('dir', dir); else url.searchParams.delete('dir');
		//window.history.pushState({}, '', url.toString());
	}

	function setActiveUI(block, state) {
		qsa('.locations-filter[data-filter]', block).forEach(function (b) {
			if ((b.getAttribute('data-filter') || '') === String(state.filter)) b.parentElement.classList.add('is-active');
			else b.parentElement.classList.remove('is-active');
		});
		qsa('.locations-sort[data-sort]', block).forEach(function (b) {
			var s = b.getAttribute('data-sort') || '';
			var d = b.getAttribute('data-dir') || '';
			if (s === state.sort && d === state.dir) b.classList.add('is-active');
			else b.classList.remove('is-active');
		});
	}

	function paginateVisible(block, attrs) {
		var grid = qs('[data-locations-grid]', block);
		if (!grid) return;

		var allItems = qsa('.filtr-item', grid);
		var visible = allItems.filter(function (el) {
			return el.offsetParent !== null &&
				getComputedStyle(el).display !== 'none' &&
				getComputedStyle(el).visibility !== 'hidden' &&
				getComputedStyle(el).opacity !== '0';
		});

		var perPage = parseInt(attrs.postsPerPage || 6, 10);
		if (!perPage || perPage < 1) perPage = 6;

		var st = parseJSONAttr(block, 'data-state', { page: 1 });
		var page = Math.max(1, parseInt(st.page || 1, 10) || 1);

		var totalPages = Math.max(1, Math.ceil(visible.length / perPage));
		page = Math.min(page, totalPages);

		var start = (page - 1) * perPage;
		var end = start + perPage;

		visible.forEach(function (el, idx) {
			if (idx >= start && idx < end) el.classList.remove('is-page-hidden');
			else el.classList.add('is-page-hidden');
		});

		renderPagination(block, attrs, page, totalPages);

		st.page = page;
		block.setAttribute('data-state', JSON.stringify(st));
	}

	function initBlock(block) {
		var attrs = parseJSONAttr(block, 'data-attrs', {});
		var state = parseJSONAttr(block, 'data-state', { filter: 'all', region: '', page: 1, sort: 'title', dir: 'asc', termMap: {} });
		var grid = qs('.filtr-container', block);
		if (!grid) return;

		// seed from query params
		var url = new URL(window.location.href);
		var qpRegion = url.searchParams.get('region') || '';
		var qpPaged = parseInt(url.searchParams.get('paged') || '1', 10) || 1;
		var qpSort = url.searchParams.get('sort') || state.sort || 'title';
		var qpDir = url.searchParams.get('dir') || state.dir || 'asc';

		if (qpRegion && state.termMap && state.termMap[qpRegion]) {
			state.region = qpRegion;
			state.filter = state.termMap[qpRegion];
		}
		state.page = qpPaged;
		state.sort = qpSort;
		state.dir = qpDir;

		block.setAttribute('data-state', JSON.stringify(state));

		var f = new Filterizr(grid, {
			layout: 'sameSize',
			filter: state.filter === 'all' ? 'all' : parseInt(state.filter, 10),
		});

		// Sort by custom data-* attributes: omit "data-" when calling sort (e.g. data-title => sort('title','asc'))
		f.sort(state.sort, state.dir);

		setActiveUI(block, state);
		setTimeout(function () { paginateVisible(block, attrs); }, 0);

		block.addEventListener('click', function (e) {
			var btn = e.target.closest('a');
			if (!btn) return;

			// filter
			if (btn.classList.contains('locations-filter') && btn.hasAttribute('data-filter')) {
				e.preventDefault();
				var filter = btn.getAttribute('data-filter') || 'all';
				var regionSlug = btn.getAttribute('data-region') || '';
				state.page = 1;

				if (filter === 'all') {
					state.filter = 'all';
					state.region = '';
					f.filter('all');
				} else {
					state.filter = parseInt(filter, 10);
					state.region = regionSlug || '';
					f.filter(state.filter);
				}

				block.setAttribute('data-state', JSON.stringify(state));
				setActiveUI(block, state);
				updateUrl(attrs, state.region, state.page, state.sort, state.dir);
				setTimeout(function () { paginateVisible(block, attrs); }, 0);
				return;
			}

			// sort
			if (btn.classList.contains('locations-sort') && btn.hasAttribute('data-sort')) {
				e.preventDefault();
				state.sort = btn.getAttribute('data-sort') || 'title';
				state.dir = btn.getAttribute('data-dir') || 'asc';
				state.page = 1;

				f.sort(state.sort, state.dir);

				block.setAttribute('data-state', JSON.stringify(state));
				setActiveUI(block, state);
				updateUrl(attrs, state.region, state.page, state.sort, state.dir);
				setTimeout(function () { paginateVisible(block, attrs); }, 0);
				return;
			}

			// pagination
			if (btn.hasAttribute('data-page')) {
				e.preventDefault();
				state.page = parseInt(btn.getAttribute('data-page') || '1', 10) || 1;
				block.setAttribute('data-state', JSON.stringify(state));
				updateUrl(attrs, state.region, state.page, state.sort, state.dir);
				paginateVisible(block, attrs);
				return;
			}
			if (btn.hasAttribute('data-page-prev')) {
				e.preventDefault();
				state.page = Math.max(1, (parseInt(state.page || 1, 10) || 1) - 1);
				block.setAttribute('data-state', JSON.stringify(state));
				updateUrl(attrs, state.region, state.page, state.sort, state.dir);
				paginateVisible(block, attrs);
				return;
			}
			if (btn.hasAttribute('data-page-next')) {
				e.preventDefault();
				state.page = (parseInt(state.page || 1, 10) || 1) + 1;
				block.setAttribute('data-state', JSON.stringify(state));
				updateUrl(attrs, state.region, state.page, state.sort, state.dir);
				paginateVisible(block, attrs);
				return;
			}
		});
	}

	function init() { qsa('[data-locations-block]').forEach(initBlock); }
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
